<template>
  <div class="animated fadeIn pb-8 admin-categories">
    <div v-if="!loaded" class="d-flex flex-column align-items-center mt-8 py-6">
      <atom-spinner :animation-duration="1000" :size="80" :color="'#EF6C00'" />
      <p class="primary--text font-weight-bold mt-4">
        در حال بارگذاری اطلاعات...
      </p>
    </div>
    <div v-else>
      <v-card class="common-card">
        <div>
          <h4 class="c-grey">دسته‌بندی‌ها</h4>
        </div>
        <hr class="mt-5" />
        <v-row>
          <v-col cols="12" class="d-none d-md-inline">
            <v-btn
              class="shopPrimary white--text mt-3"
              style="float: left"
              height="48"
              @click="newCategoryDialog()"
            >
              <v-icon class="white--text me-1"> mdi-plus-box-multiple </v-icon>
              ثبت دسته‌بندی جدید
            </v-btn>
          </v-col>
          <v-col cols="12" class="d-block d-sm-none">
            <v-btn
              class="shopPrimary white--text mt-3"
              style="float: left"
              height="48"
              block
              @click="newCategoryDialog()"
            >
              <v-icon class="white--text me-1"> mdi-plus-box-multiple </v-icon>
              ثبت دسته‌بندی جدید
            </v-btn>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <div class="custom-input mt-3">
              <v-text-field
                outlined
                dense
                label="جستجو در عنوان دسته‌بندی..."
                v-model="filteredTitle"
                color="#EF6C00"
                prepend-inner-icon="$Search"
              >
                <template v-slot:append>
                  <v-icon
                    v-if="filteredTitle.length"
                    class="red--text"
                    @click="filteredTitle = ''"
                    >mdi-close-circle-outline
                  </v-icon>
                </template>
              </v-text-field>
            </div>
          </v-col>
          <v-col cols="12" sm="6">
            <v-switch
              v-model="withOutDescription"
              label="نمایش دسته‌بندی‌های فاقد توضیحات"
              @change="descriptionFilter"
              style="font-size: 12px"
              class="float-sm-left"
            >
            </v-switch>
          </v-col>
        </v-row>

        <div class="custom-table mt-3">
          <div class="custom-table-vue">
            <v-data-table
              responsive
              show-empty
              :current-page="currentPage"
              :items-per-page="perPage"
              :page.sync="currentPage"
              :items="computedCategories"
              :headers="headers"
              striped
              hide-default-footer
              no-data-text="no_results_text"
            >
              <template v-slot:head()="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.label }}
                </div>
              </template>
              <template v-slot:no-data>
                <div
                  style="text-align: center; vertical-align: middle"
                  class="mt-2"
                >
                  <p>موردی جهت نمایش وجود ندارد.</p>
                </div>
              </template>
              <template v-slot:[`item.index`]="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.index + 1 + perPage * (currentPage - 1) }}
                </div>
              </template>
              <template v-slot:cell="data">
                <div style="text-align: center; vertical-align: middle">
                  {{ data.value }}
                </div>
              </template>

              <template v-slot:[`item.operation`]="{ item }">
                <div style="vertical-align: middle; text-align: center">
                  <v-btn class="warning white--text" @click="editDialog(item)">
                    <v-icon class="white--text me-1">
                      mdi-pencil-outline
                    </v-icon>
                    ویرایش
                  </v-btn>
                </div>
              </template>
              <template v-slot:[`item.description`]="{ item }">
                <div v-if="item.description.length > 20">
                  <v-tooltip top>
                    <template v-slot:activator="{ on, attr }">
                      <span v-on="on" v-bind="attr">
                        {{ item.description.slice(0, 20) }} </span
                      ><span>...</span>
                    </template>
                    <div>
                      <span>
                        {{ item.description }}
                      </span>
                    </div>
                  </v-tooltip>
                </div>
                <div v-else>{{ item.description }}</div>
              </template>
            </v-data-table>
          </div>
          <v-row class="mt-6">
            <v-col>
              <div class="d-flex flex-row">
                <span class="c-grey pt-2">نمایش در هر صفحه</span>
                <div class="ms-3 me-3 number-box">
                  <v-select
                    outlined
                    v-model="perPage"
                    :items="perPageItems"
                    @change="currentPage = 1"
                  >
                  </v-select>
                </div>
              </div>
            </v-col>
            <v-col class="d-flex flex-row">
              <span class="c-grey pt-2"> برو به صفحه </span>
              <div class="ms-3 me-3 number-box">
                <v-select
                  outlined
                  v-model="whichPage"
                  type="number"
                  @change="goToPage()"
                  @click="goToPage()"
                  :items="computedIndex"
                ></v-select>
              </div>
            </v-col>
            <v-col class="text-sm-center">
              <div>
                <v-pagination
                  v-model="currentPage"
                  prev-icon="$ArrowLeft"
                  next-icon="$ArrowRight"
                  :length="Math.ceil(computedCategories.length / perPage)"
                  :total-visible="5"
                  class="float-sm-end"
                >
                </v-pagination>
              </div>
            </v-col>
          </v-row>
        </div>
      </v-card>
      <v-dialog v-model="openEditDialog" width="400">
        <v-card>
          <v-card-title class="white"
            ><v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  ویرایش دسته‌بندی
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="openEditDialog = false"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row>
          </v-card-title>
          <hr class="mt-0 pt-0" />
          <v-card-text class="pa-3">
            <v-text-field
              v-model="selectedCategory.name"
              outlined
              dense
              placeholder="عنوان دسته‌بندی"
            >
            </v-text-field>
            <v-textarea
              v-model="selectedCategory.description"
              outlined
              rows="3"
              placeholder="توضیحات"
            >
            </v-textarea>
            <div class="text-left pe-3 pb-4 pt-0">
              <v-btn
                class="green-mainBtn me-3"
                @click="doEditCategory()"
                :disabled="!selectedCategory.name"
              >
                تایید
              </v-btn>
              <v-btn class="red-mainBtn" @click="openEditDialog = false">
                بستن
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="openNewCategoryDialog" width="400">
        <v-card>
          <v-card-title class="white"
            ><v-row>
              <v-col>
                <h4 class="c-grey mb-0 pb-0" style="vertical-align: middle">
                  ثبت دسته‌بندی جدید
                </h4>
              </v-col>
              <v-col cols="2" class="text-left pt-2">
                <span class="pointer" @click="cancelNewCategory()"
                  ><v-icon>$Close</v-icon></span
                >
              </v-col>
            </v-row></v-card-title
          >
          <hr class="mt-0 pt-0" />

          <v-card-text class="pa-3">
            <v-text-field
              v-model="newCategory.name"
              outlined
              dense
              placeholder="عنوان دسته‌بندی"
            >
            </v-text-field>
            <v-textarea
              v-model="newCategory.description"
              outlined
              rows="3"
              placeholder="توضیحات"
            >
            </v-textarea>
            <div class="text-left pe-3 pb-4 pt-0">
              <v-btn class="green-mainBtn me-3" @click="addCategory()">
                تایید
              </v-btn>
              <v-btn class="red-mainBtn" @click="cancelNewCategory()">
                بستن
              </v-btn>
            </div>
          </v-card-text>
        </v-card>
      </v-dialog>
    </div>
  </div>
</template>
<script>
import Axios from "axios";
import { AtomSpinner } from "epic-spinners";

export default {
  components: {
    AtomSpinner,
  },
  data() {
    return {
      whichPage: 1,
      loaded: false,
      currentPage: 1,
      perPage: 5,
      deviceType: "",
      filteredTitle: "",
      headers: [
        { value: "index", text: "ردیف", sortable: false },
        { value: "name", text: "عنوان", sortable: false },
        { value: "description", text: "توضیحات", sortable: false },
        { value: "operation", text: "عملیات", sortable: false },
      ],
      perPageItems: [5, 10, 20],
      selectedCategory: {},
      editingCategory: {},
      openEditDialog: false,
      categoryTitle: "",
      categoryDescription: "",
      withOutDescription: false,
      openNewCategoryDialog: false,
      newCategory: {},
      categories: [],
      allCategories: [],
    };
  },
  methods: {
    goToPage() {
      this.currentPage = Number(this.whichPage);
    },
    getCategories() {
      Axios.get(this.baseUrl + "/satrapp/shop/categories/list", {
        headers: {
          Authorization: "Bearer: " + localStorage.getItem("token"),
        },
      })
        .then((res) => {
          if (res.status == 200) {
            this.loaded = true;
            this.categories = res.data;
            this.allCategories = res.data;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );

            this.toast(title, "error");
            this.loaded = true;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.loaded = true;
        });
    },
    addCategory() {
      Axios.post(
        this.baseUrl + "/satrapp/shop/category/new",
        {
          name: this.newCategory.name,
          description: this.newCategory.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 201) {
            this.toast(res.data.message, "success");
            this.newCategory = {};
            this.openNewCategoryDialog = false;
            this.getCategories();
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");
            this.openNewCategoryDialog = false;
          }
        })
        .catch((err) => {
          this.toast(err.response.data, "error");
          this.openNewCategoryDialog = false;
        });
    },
    doEditCategory() {
      Axios.patch(
        this.baseUrl +
          "/satrapp/shop/category/edit/" +
          this.selectedCategory.id,
        {
          name: this.selectedCategory.name,
          description: this.selectedCategory.description,
        },
        {
          headers: {
            Authorization: "Bearer: " + localStorage.getItem("token"),
          },
        }
      )
        .then((res) => {
          if (res.status == 200) {
            this.getCategories();
            this.openEditDialog = false;
          } else {
            const title = (
              <div>
                <h5>خطا </h5>
                <span>مشکلی پیش آمده. مجددا امتحان کنید.</span>
              </div>
            );
            this.toast(title, "error");

            this.openEditDialog = false;
          }
        })
        .catch((err) => {
          this.toast("خطا: " + err.response.data, "error");
          this.openEditDialog = false;
        });
    },
    editDialog(item) {
      // this.editingCategory = JSON.parse(JSON.stringify(item));
      this.selectedCategory = JSON.parse(JSON.stringify(item));
      this.openEditDialog = true;
    },
    descriptionFilter() {
      let noDescription;
      if (this.withOutDescription) {
        noDescription = this.categories.filter((x) => x.description == "");
        this.categories = noDescription;
      } else {
        this.categories = this.allCategories;
      }
    },
    newCategoryDialog() {
      this.openNewCategoryDialog = true;
    },

    cancelNewCategory() {
      this.openNewCategoryDialog = false;
      this.newCategory = {};
    },
  },
  mounted() {
    this.getCategories();
  },
  computed: {
    computedCategories() {
      let filtered;
      if (this.filteredTitle.length) {
        filtered = this.categories.filter((x) =>
          x.name.toLowerCase().includes(this.filteredTitle.toLowerCase())
        )
          ? this.categories.filter((x) =>
              x.name.toLowerCase().includes(this.filteredTitle.toLowerCase())
            )
          : "";
      } else {
        filtered = this.categories;
      }
      return filtered;
    },
    computedIndex() {
      let arr = [];
      let computedLength = this.computedCategories.length;
      let arrLength = Math.ceil(computedLength / this.perPage);
      for (let i = 1; i <= arrLength; i++) {
        arr.push(i);
      }
      return arr;
    },
  },
};
</script>
<style lang="scss">
.admin-categories {
  .custom-input {
    .v-input__slot {
      width: 100% !important;
    }
    .v-input__control {
      flex-direction: row !important;
    }
    .v-text-field .v-input__control,
    .v-text-field fieldset {
      min-height: 45px !important;
      border-color: #ef6c00 !important;
    }
    .v-label:not(.v-label--active) {
      transform: translateY(2px);
    }
  }
}
</style>
